import { get } from 'lodash';

export const fetchTranslation = (key) => {
  return get(window.translations, key) || `[Missing Translation]: ${key}`;
};
